// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderBlockInfoLabel_root__wv4Um"};